import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatDividerModule],
  template: `
    <div class="login-head">
      <span class="login-icon"><mat-icon>shield_lock</mat-icon></span>
      <div><h2 mat-dialog-title>Вход в систему</h2><p>Используйте корпоративную учётную запись</p></div>
    </div>
    <mat-dialog-content>
      <button mat-flat-button class="oauth" (click)="oauth()" [disabled]="auth.isLoading()">
        <span class="oauth-content">
          <mat-icon class="oauth-icon">key</mat-icon>
          <span class="oauth-copy"><strong>Войти через OAuth2 / SSO</strong><small>Перенаправим на сервер авторизации</small></span>
          <mat-icon class="tail">arrow_forward</mat-icon>
        </span>
      </button>
      @if (auth.lastError()) {
        <p class="error"><mat-icon>error</mat-icon>{{ auth.lastError() }}</p>
      }
      <div class="divider"><span></span><small>или</small><span></span></div>
      <button mat-stroked-button class="native" disabled><mat-icon>password</mat-icon><span><strong>Логин и пароль</strong><small>Нативная авторизация пока недоступна</small></span></button>
    </mat-dialog-content>
    <mat-dialog-actions align="end"><button mat-button mat-dialog-close>Отмена</button></mat-dialog-actions>
  `,
  styles: [`
    .login-head{display:flex;align-items:center;gap:15px;padding:26px 26px 6px}.login-icon{display:grid;place-items:center;width:48px;height:48px;border-radius:15px;background:var(--primary-soft);color:var(--primary)}h2{padding:0!important;margin:0!important;font-size:23px!important}.login-head p{margin:5px 0 0;color:var(--muted);font-size:13px}mat-dialog-content{padding:18px 26px!important}.oauth,.native{width:100%;height:68px;border-radius:16px;justify-content:flex-start;padding:0 16px}.oauth-content{display:grid;width:100%;grid-template-columns:28px minmax(0,1fr) 24px;align-items:center;column-gap:12px}.oauth-copy,.native span{display:flex;min-width:0;flex-direction:column;align-items:flex-start;line-height:1.25}.oauth-copy strong{width:100%;text-align:left}.oauth small,.native small{font-size:11px;opacity:.75;margin-top:3px}.oauth-icon,.oauth .tail{margin:0!important}.oauth .tail{justify-self:end}.native>mat-icon{margin-right:8px}.divider{display:flex;align-items:center;gap:12px;margin:17px 0;color:var(--muted)}.divider span{height:1px;background:var(--border);flex:1}.divider small{font-size:11px}.error{display:flex;align-items:center;gap:8px;margin:14px 0 0;color:var(--error,#c62828);font-size:13px}.error mat-icon{font-size:18px;width:18px;height:18px}mat-dialog-actions{padding:0 22px 18px}
  `]
})
export class LoginDialogComponent {
  readonly auth = inject(AuthService);
  private readonly ref = inject(MatDialogRef<LoginDialogComponent>);
  oauth(): void {
    this.ref.close();
    this.auth.login();
  }
}
